<vdms-hq-ui-results-wrapper
  [configuration]="{ headerActions: (headerActions$ | async) }"
  [breadcrumbs]="[{ name: 'pages.fields.field_values' | translate }]"
  [dataSource]="fieldValuesDataSource"
  (headerAction)="handleAction($event)"
  [class.dialog-context]="dialogContext()"
>
  <vdms-hq-ui-multiple-data-presentation
    [tableId]="'fields-admin-field-values-table'"
    [dataSource]="fieldValuesDataSource"
    [configuration]="resolvedViewConfiguration"
    (action)="handleAction($event)"
  />
</vdms-hq-ui-results-wrapper>
